// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__9R5ck","required":"FormLabel_required__YwLhO"};